import styled from 'styled-components'

export default styled.div`
  width: 100%;
`



// WEBPACK FOOTER //
// ./src/components/HeaderSidebarLayout/Main.js